/**
 * HOS API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * Contact: info@hos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Injector, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';
import {HosBaseService} from "./hos-base.service";

import { Observable }                                        from 'rxjs';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import {BlacklistDomain} from '../model/blacklistDomain';


@Injectable()
export class BlacklistService extends HosBaseService {

    // protected basePath = 'https://localhost';
    // public defaultHeaders = new HttpHeaders();
    // public configuration = new Configuration();

    /*constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }*/

    constructor(injector: Injector) {
        super(injector);
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    /*private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }*/


    /**
     * Return the blacklist
     *
     * @param search string
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllBlacklistDomains(search?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BlacklistDomain>>;
    public getAllBlacklistDomains(search?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BlacklistDomain>>>;
    public getAllBlacklistDomains(search?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BlacklistDomain>>>;
    public getAllBlacklistDomains(search?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
      let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (search !== undefined && search !== null) {
            queryParameters = queryParameters.set('searchQuery', <any>search);
        }

        let headers = this.getDefaultHeaders();

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<BlacklistDomain>(`${this.getBasePath()}/api/webtools/v1/blacklist-domains`,
            {
                params: queryParameters,
                // withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

  public removeBlacklistDomain(domainId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public removeBlacklistDomain(domainId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public removeBlacklistDomain(domainId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public removeBlacklistDomain(domainId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    if (domainId === null || domainId === undefined) {
      throw new Error('Required parameter domainId was null or undefined when calling removeBlacklistDomain.');
    }


    let headers = this.getDefaultHeaders();

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    return this.httpClient.delete<any>(`${this.getBasePath()}/api/webtools/v1/blacklist-domains/${encodeURIComponent(String(domainId))}`,
      {
        // withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Add domain to the blacklist
   *
   * @param body The domain
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  /*
  public addDomain(body?: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
  public addDomain(body?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
  public addDomain(body?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
  public addDomain(body?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

    let headers = this.getDefaultHeaders();

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
    ];
    const httpHeaderAcceptSelected: string | undefined = undefined; // this.configuration.selectHeaderAccept(httpHeaderAccepts);
    if (httpHeaderAcceptSelected != undefined) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    // to determine the Content-Type header
    const consumes: string[] = [
    ];

    const httpContentTypeSelected: string | undefined = undefined; // this.configuration.selectHeaderContentType(consumes);
    if (httpContentTypeSelected != undefined) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<any>(`${this.getBasePath()}/api/webtools/v1/blacklist-domains`,
      body,
      {
        // withCredentials: this.configuration.withCredentials,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
  */

  /**
   * Add domain to the blacklist
   *
   * @param body The domain object containing domain, status, and riskGroup
   * @param observe set whether or not to return the data Observable as the body, response, or events. Defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public addDomain(
    body: { domain: string; status: BlacklistDomain.StatusEnum; riskGroup?: string },
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<any> {

    let headers = this.getDefaultHeaders();

    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = httpHeaderAccepts[0];
    if (httpHeaderAcceptSelected) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = consumes[0];
    if (httpContentTypeSelected) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.post<any>(
      `${this.getBasePath()}/api/webtools/v1/blacklist-domains`,
      body,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }

  /**
   * Update an existing domain in the blacklist
   *
   * @param id The ID of the domain to update
   * @param body The domain object containing domain, status, and riskGroup
   * @param observe set whether or not to return the data Observable as the body, response, or events. Defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public updateDomain(
    id: number,
    body: { domain: string; status: BlacklistDomain.StatusEnum; riskGroup?: string },
    observe: 'body' = 'body',
    reportProgress: boolean = false
  ): Observable<any> {

    let headers = this.getDefaultHeaders();

    let httpHeaderAccepts: string[] = ['application/json'];
    const httpHeaderAcceptSelected: string | undefined = httpHeaderAccepts[0];
    if (httpHeaderAcceptSelected) {
      headers = headers.set('Accept', httpHeaderAcceptSelected);
    }

    const consumes: string[] = ['application/json'];
    const httpContentTypeSelected: string | undefined = consumes[0];
    if (httpContentTypeSelected) {
      headers = headers.set('Content-Type', httpContentTypeSelected);
    }

    return this.httpClient.put<any>(
      `${this.getBasePath()}/api/webtools/v1/blacklist-domains/${id}`,
      body,
      {
        headers: headers,
        observe: observe,
        reportProgress: reportProgress
      }
    );
  }
}
